import React, { useEffect, useState } from 'react';
import "../Styles/Resort.css";
import Roi1 from "../Resource/Resort/exclusive.png";
import Roi2 from "../Resource/Resort/money.png";
import Roi3 from "../Resource/Resort/resort.png";
import RoiBanner2 from "../Resource/aboutbg.png";
import RoiBanner from "../Resource/MapInfo/madura-img2.png";
import RoiBanner3 from "../Resource/Roi/Roi_banner_2.jpg";
import realimg1 from '../Resource/Roi/realimg1.png'
import realimg2 from '../Resource/Roi/realimg2.JPG'
import clubhouse from '../Resource/clubhouse1.png'

const roiDataForResort = [
  {
    title: "A Resort That Lives With You",
    bottom_title: "Exclusive Access",
    description: "Nestled within the heart of Prasiddh, our resort offers world-class amenities designed for wellness, leisure, and celebration—right at your doorstep. Whether it’s a weekend retreat or a wedding celebration, the resort adds both lifestyle value and rental income potential to your property.",
    icon: Roi1,
    images: [clubhouse],
  },
  {
    title: "ROI On Resort",
    bottom_title: "Destination Appeal",
    description: "Resorts generate passive income through rentals, tourism, and hospitality. With seasonal demand and leisure trends rising, they offer high ROI potential, branding value, and consistent earnings across vacation and event seasons.",
    icon: Roi3,
    images: [RoiBanner2],
  },
  {
    title: "Benefits Of Resorts",
    bottom_title: "Revenue Share",
    description: "Other ventures include agro-tourism, eco-retreats, and commercial leasing. These assets cater to niche markets, enable revenue diversity, and offer low-risk income opportunities by leveraging unique land usage and lifestyle demand.",
    icon: Roi2,
    images: [RoiBanner3, RoiBanner, RoiBanner3],
  },
];

const Resort = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [animationKey, setAnimationKey] = useState(0);
  const activeData = roiDataForResort[activeIndex];
  const hasMultipleImages = activeData.images.length > 1;

  // Carousel auto-switch
  useEffect(() => {
    if (!hasMultipleImages) return;
    const imgInterval = setInterval(() => {
      setCarouselIndex((prev) =>
        prev === activeData.images.length - 1 ? 0 : prev + 1
      );
    }, 3000);
    return () => clearInterval(imgInterval);
  }, [activeIndex, activeData.images.length]);

  return (
     <div class="Resort-container" id='Resort'>
    <div class="glass-content">
        <div className='Roi-container Roi-container-for-resort'>
      <div className='Roi-sub-container-1'>
        <div 
          key={`title-${animationKey}`} 
          className='Roi-card-title slide-in-right'
        >
          {activeData.title}
        </div>
        <div 
          key={`description-${animationKey}`} 
          className='Roi-card-content slide-in-right slide-in-delayed'
        >
          {activeData.description}
        </div>

        <div className='Roi-bottom-cards-holder'>
          {roiDataForResort.map((item, index) => (
            <React.Fragment key={index}>
              <div
                className={`Roi-bottom-card animate ${activeIndex === index ? 'active-card' : ''}`}
              >
                <div className='Roi-bottom-card-image'>
                  <img src={item.icon} alt={item.bottom_title} />
                </div>
                <div className='Roi-bottom-card-title'>{item.bottom_title}</div>
              </div>
              {index < roiDataForResort.length - 1 && <div className='Roi-bottom-card-line'></div>}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className='Roi-sub-container-2 animate'>
        <div className="carousel-wrapper" style={{ position: 'relative' }}>
          <img
            src={activeData.images[carouselIndex]}
            alt='ROI Visual'
            className='carousel-image'
          />

          {hasMultipleImages && (
            <div className="Gallery-pagination-dots-holder">
              <div
                className="Gallery-pagination-dots-holder-background-highlighter"
                style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}
              >
                {activeData.images.map((_, i) => (
                  <div
                    key={i}
                    className={i === carouselIndex ? 'pagination-dot-active' : 'pagination-dot'}
                    onClick={() => setCarouselIndex(i)}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    </div>
    </div>
  );
};

export default Resort;

